import { useState, useMemo } from "react";

export const useSortableTable = (items, filteredItems, config = { dataKey: null, order: null }) => {
  const [sortConfig, setSortConfig] = useState(config);
  const sortedItems = useMemo(() => {
    let sortableItems = [...items];
    let sortableFilteredItems = [...filteredItems];
    if (sortConfig?.dataKey != null) {
      const reversed = sortConfig?.order === "asc" ? 1 : -1;
      sortableItems.sort((a, b) => {
        if (a[sortConfig.dataKey] === null) return 1;
        if (b[sortConfig.dataKey] === null) return -1;
        if (a[sortConfig.dataKey] === null && b[sortConfig.dataKey] === null) return 0;
        let itemOne = a[sortConfig.dataKey];
        let itemTwo = b[sortConfig.dataKey];
        return (
          reversed *
          itemOne.toString().toLowerCase().localeCompare(itemTwo.toString().toLowerCase(), undefined, {
            numeric: true,
          })
        );
      });
      sortableFilteredItems.sort((a, b) => {
        if (a[sortConfig.dataKey] === null) return 1;
        if (b[sortConfig.dataKey] === null) return -1;
        if (a[sortConfig.dataKey] === null && b[sortConfig.dataKey] === null) return 0;
        return (
          reversed *
          a[sortConfig.dataKey]
            .toString()
            .toLowerCase()
            .localeCompare(b[sortConfig.dataKey].toString().toLowerCase(), undefined, {
              numeric: true,
            })
        );
      });
    }
    return { sortableItems, sortableFilteredItems };
  }, [items, filteredItems, sortConfig]);

  const requestSort = (key) => {
    const orderOfSort =
      sortConfig && sortConfig.dataKey && sortConfig.order && key === sortConfig.dataKey && sortConfig.order === "asc"
        ? "desc"
        : "asc";
    setSortConfig({ dataKey: key, order: orderOfSort });
  };

  return {
    items: sortedItems.sortableItems,
    filteredItems: sortedItems.sortableFilteredItems,
    requestSort,
    sortConfig,
  };
};
